/**
 * Reports FE wrapper.
 *
 * BE route: GET /groups/:id/reports/:view
 * Query: paidFrom, paidTo, dueFrom, dueTo, paymentMethod, status (mind opcionális).
 */

import type {
  ReportFilters,
  ReportByStudentResponse,
  ReportByRequirementResponse,
  ReportByMethodResponse,
} from '@pta/types';
import { apiCall } from './client';

function filtersToQuery(filters: ReportFilters): Record<string, string | undefined> {
  return {
    paidFrom: filters.paidFrom ?? undefined,
    paidTo: filters.paidTo ?? undefined,
    dueFrom: filters.dueFrom ?? undefined,
    dueTo: filters.dueTo ?? undefined,
    paymentMethod: filters.paymentMethod ?? undefined,
    status: filters.status ?? undefined,
  };
}

export function fetchByStudentReport(
  groupId: number,
  filters: ReportFilters,
): Promise<ReportByStudentResponse> {
  return apiCall(`/groups/${groupId}/reports/by-student`, {
    query: filtersToQuery(filters),
  });
}

export function fetchByRequirementReport(
  groupId: number,
  filters: ReportFilters,
): Promise<ReportByRequirementResponse> {
  return apiCall(`/groups/${groupId}/reports/by-requirement`, {
    query: filtersToQuery(filters),
  });
}

export function fetchByMethodReport(
  groupId: number,
  filters: ReportFilters,
): Promise<ReportByMethodResponse> {
  return apiCall(`/groups/${groupId}/reports/by-method`, {
    query: filtersToQuery(filters),
  });
}
